import './App.css';
import './app/theme/layout/layout'
import Layout from './app/theme/layout/layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  // Suppress ResizeObserver loop error in development
      const resizeObserverErr = /(ResizeObserver loop limit exceeded)/;

      window.addEventListener('error', (e) => {
        if (resizeObserverErr.test(e.message)) {
          e.stopImmediatePropagation();
        }
        });
        
  return (
    <>

     <ToastContainer position="top-right" autoClose={3000} />
     <Layout/>
     
    </>
  );
}

export default App;
